import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SignIn = function SignIn(_ref) {
  var variant = _ref.variant,
      sx = _ref.sx;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Button, {
    sx: sx,
    variant: variant,
    href: "/users/sign_in",
    "data-element": "Button",
    "data-component": "SignIn",
    "data-source-file": "auth-buttons.tsx",
    children: t('Sign in')
  });
};

var SignUp = function SignUp(_ref2) {
  var sx = _ref2.sx;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_jsx(Button, {
    sx: sx,
    variant: "contained",
    href: "/users/sign_up",
    "data-element": "Button",
    "data-component": "SignUp",
    "data-source-file": "auth-buttons.tsx",
    children: t('Sign up')
  });
};

var AuthButtons = function AuthButtons(_ref3) {
  var signinEnabled = _ref3.signinEnabled,
      signupEnabled = _ref3.signupEnabled,
      containerSx = _ref3.containerSx,
      sx = _ref3.sx,
      signInVariant = _ref3.signInVariant;
  return /*#__PURE__*/_jsxs(Box, {
    sx: mergeSxProps({
      display: 'flex',
      width: 1,
      gap: 1.5
    }, containerSx),
    "data-element": "Box",
    "data-component": "AuthButtons",
    "data-source-file": "auth-buttons.tsx",
    children: [signinEnabled ? /*#__PURE__*/_jsx(SignIn, {
      sx: sx,
      variant: signInVariant !== null && signInVariant !== void 0 ? signInVariant : signupEnabled ? 'text' : 'contained'
    }) : null, signupEnabled ? /*#__PURE__*/_jsx(SignUp, {
      sx: sx
    }) : null]
  });
};

export default AuthButtons;